import { ARTICLES_PART1 } from "@/data/articlesPart1";
import { ARTICLES_PART2 } from "@/data/articlesPart2";
import { ARTICLES_PART3 } from "@/data/articlesPart3";
import { ARTICLES_PART4 } from "@/data/articlesPart4";
import { ARTICLES_PART5 } from "@/data/articlesPart5";

export const ARTICLES = [...ARTICLES_PART1, ...ARTICLES_PART2, ...ARTICLES_PART3, ...ARTICLES_PART4, ...ARTICLES_PART5];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
